export default __webpack_public_path__ + "static/media/UserTie.211a97b1.svg";